import { jsx } from 'react/jsx-runtime';
import { Grid } from '@mui/material';
import { QuantityInput } from '../../QuantityInput.js';
import '../../../tslib.es6-17e0406b.js';
import 'react';
import 'react-number-format';

const Quantity = ({ label, value = 0, name, handleChange, integer = 10, decimal = 0, }) => (jsx(Grid, Object.assign({ item: true, lg: 6, md: 12, sm: 12, xs: 12 }, { children: jsx(QuantityInput, { label: label, value: value, name: `${name}`, handleChange: handleChange, integer: integer, decimal: decimal }) })));

export { Quantity };
